/**
 * Listing lifecycle balance ("living market" engine).
 * The exchange always shows exactly LISTED_SLOTS coins = every permanent major
 * plus a rotating set of meme coins. Meme coins can be delisted (dead volume or
 * a floored rug), rest in the delisted graveyard, then get a chance to revive
 * as a "{name} 2.0" rebrand. One transition at a time, spaced by cooldowns.
 */

export const LISTING_CONFIG = {
  /** total coins visible on the exchange at once (majors + rotating memes) */
  listedSlots: 8,

  /** ms between any two listing-system transitions (list / delist / revive) */
  transitionCooldown: 45_000,

  // === Delist triggers (evaluated per listed meme coin) ===
  /** a meme must trade at least this long before it can be delisted */
  minListedAge: 240_000,
  /** delist if the price has sat at/under minPrice*ratio for delistFloorTime */
  delistFloorRatio: 1.25,
  delistFloorTime: 120_000,
  /** "dead volume": 24h change stayed within +-this pct for delistStaleTime */
  delistStalePct: 3,
  delistStaleTime: 300_000,
  /** small random delist chance per eligible coin per evaluation (aging out) */
  delistRandomChance: 0.06,
  /** how often (ms) delist conditions are re-evaluated */
  evalInterval: 20_000,

  // === Forced liquidation on delist ===
  /** holder is paid this fraction of the last price when a coin is delisted */
  liquidationRatio: 0.6,

  // === New listing (fills empty slots) ===
  /** a freshly listed meme starts at a random multiple of its startPrice */
  listStartJitterMin: 0.7,
  listStartJitterMax: 1.6,

  // === Revival (rebrand as {name} 2.0) ===
  /** a delisted coin must rest at least this long before it can revive */
  reviveDelay: 300_000,
  /** revive chance per resting coin per evaluation once the delay has passed */
  reviveChance: 0.35,
} as const;

/** Suffix appended per rebrand generation: 1 -> "2.0", 2 -> "3.0", ... */
export function rebrandSuffix(generation: number): string {
  return generation > 0 ? ` ${generation + 1}.0` : '';
}
